import { usePendingActionRequests } from "../../../../../hooks/use-pending-action-requests.ts";
import { formatData } from "./utils.ts";
import styles from "./action-center-card.module.css"
import { Card } from "../../../../shared/card/card.tsx";
import { Avatar } from "../../../../ui/index.ts";
// import { Check, X } from "lucide-react"; // TODO: wire approve / reject actions
import { CalendarDays, Laptop, Receipt, FileText, KeyRound } from "lucide-react";

const ActionCenterCard = () => {
  const { data: apiData, loading } = usePendingActionRequests();
  const formattedData = formatData(apiData);

  const icons: any = {
    leave: CalendarDays,
    access: KeyRound,
    asset: Laptop,
    timesheet: FileText,
    reimbursement: Receipt,
  };

  const labels: any = {
    leave: "Leave",
    access: "Access",
    asset: "Asset",
    timesheet: "Timesheet",
    reimbursement: "Expense",
  };

  return (
    <Card className={`w-100 ${styles.actionCard}`}  >
      <div className={styles.header}>
        <h6 className="heading-sm mb-0">Action Center</h6>
      </div>

      {loading && <p>Loading...</p>}

      <div className={styles.actionsList}>
        {formattedData.map((item) => {
          const Icon = icons[item.type];

          return (
            <div key={item.id} className={styles.item}>
              <div className={styles.iconBox}>
                <Icon size={16} />
              </div>

              <Avatar name={item.name} size="md" />

              <div className={styles.content}>
                <div className={styles.topRow}>
                  <p className={styles.name}>{item.name}</p>
                  <span className="badge--warning">
                    {labels[item.type]}
                  </span>
                </div>

                <p className={styles.desc}>
                  {item.summary ? `— ${item.summary}` : ""}   {item.detail}
                </p>
              </div>

              {/* TODO: enable when approve/reject handlers exist
              <div className={styles.actions}>
                <button type="button" className={styles.approve} aria-label="Approve">
                  <Check size={16} />
                </button>
                <button type="button" className={styles.reject} aria-label="Reject">
                  <X size={16} />
                </button>
              </div>
              */}
            </div>
          );
        })}
      </div>
    </Card>
  );
};
export default ActionCenterCard;